import { get } from "services/BaseClient/Client";
import endpoints from "./EndPoints"
import headers from "services/BaseClient/Headers.json";
import { CreateUrlFilter } from "helpers/CreateURLFilter";



export const getAlarmWays = async () => {
    
    const url = `${endpoints.getAlarmWaysList}`;
    const config = headers.content_type.application_json;
    return get(url, config);
};


